import { components } from 'src/generated/v1';
import { useQueryClient } from '@tanstack/react-query';
import { $api } from './api';

export type Bom = components['schemas']['Bom'];
export type BomLine = components['schemas']['BomLine'];

export const useBoms = (productId: number) => {
  const queryClient = useQueryClient();

  const createBomMutation = $api.useMutation('post', '/products/{product_id}/boms/', {
    params: { path: { product_id: productId } },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['get', '/products/{product_id}'],
      });
      queryClient.invalidateQueries({
        queryKey: ['get', '/products/{product_id}/boms/'],
      });
    },
  });

  const deleteBomMutation = $api.useMutation('delete', '/products/boms/{bom_id}', {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['get', '/products/{product_id}'],
      });
      queryClient.invalidateQueries({
        queryKey: ['get', '/products/{product_id}/boms/'],
      });
    },
  });

  return {
    createBomMutation,
    deleteBomMutation,
  };
};

export const useProductBomsQuery = (productId: number) => {
  return $api.useQuery('get', '/products/{product_id}/boms/', {
    params: { path: { product_id: productId } },
  });
};

export const useBomLines = (bomId: number) => {
  const queryClient = useQueryClient();

  const bomLinesQuery = $api.useQuery('get', '/products/boms/{bom_id}/lines/', {
    params: { path: { bom_id: bomId } },
  });

  const createBomLineMutation = $api.useMutation('post', '/products/boms/{bom_id}/lines/', {
    params: { path: { bom_id: bomId } },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['get', '/products/{product_id}/boms/'],
      });
      queryClient.invalidateQueries({
        queryKey: ['get', '/products/boms/{bom_id}/lines/'],
      });
    },
  });

  const updateBomLineMutation = $api.useMutation('put', '/products/boms/lines/{line_id}', {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['get', '/products/{product_id}/boms/'],
      });
      queryClient.invalidateQueries({
        queryKey: ['get', '/products/boms/{bom_id}/lines/'],
      });
    },
  });

  const deleteBomLineMutation = $api.useMutation('delete', '/products/boms/lines/{line_id}', {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['get', '/products/{product_id}/boms/'],
      });
      queryClient.invalidateQueries({
        queryKey: ['get', '/products/boms/{bom_id}/lines/'],
      });
    },
  });

  return {
    bomLinesQuery,
    createBomLineMutation,
    updateBomLineMutation,
    deleteBomLineMutation,
  };
};
